/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { BannerService } from './banner.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner.component';
import { UserProfileService } from '../userprofile/userprofile.service';
import { BannerRoutingModule } from './banner-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '../../feature/store/store.module';
import { FormsModule } from '@angular/forms';
import { StoreFilterService } from '../../feature/store/services/storefilter.service';
import { AlertComponent } from '../../../shared/alert/alert.component';
import { AlertService } from '../../../shared/alert/alert.service';
import { CustomerPreferenceService } from '../../preference/customerpreference.service';
import { RequestlistSearchService } from '../../feature/requests/services/requestlist-searchservice';
import { LoginService } from '../../../login/login.service';

@NgModule({
  imports: [
    CommonModule,
    BannerRoutingModule,
    TranslateModule,
    StoreModule,
    FormsModule
  ],
  declarations: [ BannerComponent, AlertComponent ],
  providers : [ UserProfileService, StoreFilterService,
    RequestlistSearchService, AlertService, CustomerPreferenceService, BannerService , LoginService],
  exports : [ BannerComponent ]
})
export class BannerModule { }
